import { ChangeDetectorRef, Component, OnDestroy, OnInit, ChangeDetectionStrategy, inject, input } from '@angular/core';

import { CartItem, CartService, CartStructure } from 'app/Cart/CartService';
import { Subscription } from 'rxjs';
import { QdmService, RankItem, ServiceItem } from 'app/Services/qdm.service';
import { CartItemRowComponent } from './CartItemRow.component';
import { MealKitIconButtonComponent } from '@yoni/mealcomponents-lib';
import { ModalService } from 'app/Services/modal.service';
import { ModalCartCheckoutComponent } from '../Modal/ModalCartCheckout/ModalCartCheckout.component';
import { User, UserChildren } from 'app/Services/auth.service';
import {
  AdmissionPart,
  Enterprise,
  EnterpriseResponse,
  FullAdmissionsData,
  GestionService,
} from 'app/Services/gestion.service';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'app/Services/auth.service';
import { OrderByPipe } from 'app/Pipes/OrderBy.pipe';
import { QuantitySelectorComponent } from '../QuantitySelector/QuantitySelector.component';
import { ChildSelectorComponent } from '../ChildSelector/child-selector.component';
import { ResponsiveService } from 'app/Services/responsive.service';

@Component({
    selector: 'cart-display',
    imports: [
    CartItemRowComponent,
    MealKitIconButtonComponent,
    OrderByPipe,
    QuantitySelectorComponent,
    ChildSelectorComponent
],
    template: ` <div class="w-full h-full overflow-hidden flex flex-col">
      <div
        class="w-full items-center gap-2 px-2 flex mt-2 pb-2 border-b border-gris-3"
        >
        <div class="bg-vert-3 rounded p-1">
          <svg class="icon w-6 h-6 fg-vert-1">
            <use href="/assets/images/icons/icons.svg#commande"></use>
          </svg>
        </div>
        <p class="font-bold flex-1 fg-noir-2 text-sm">Mon Panier</p>
    
        <mk-icon-button
          (click)="this.closeCart()"
          class="md:!hidden ml-auto aspect-square w-[50px] scale-80"
          [fullscale]="true"
          direction="rtl"
          icon="cancel"
          useSvg="false"
          [label]="''"
          />
        </div>
    
        <div class="w-full overflow-hidden flex flex-col px-2 relative">
          <p class="p-4 font-bold fg-noir-2 pb-0 pt-2 md:pt-4">
            {{ this.selectedDate?.formatDate('fullDay', true) }}
          </p>
          <p class="px-4 fg-noir-2 text-sm hidden md:block">
            <span class="font-bold">Lieu de consommation: </span>
            {{
            (this.ent?.name || 'Aucun lieu de consommation').replaceAll('_', ' ')
            }}
          </p>
          <p class="px-4 fg-noir-2 text-sm hidden md:block">
            <span class="font-bold">Service</span>:
            {{
            (this.currentService?.name || 'Aucun service sélectionné').replaceAll(
            '_',
            ' '
            )
            }}
          </p>
        </div>
    
        @if (this.user && this.user.children.length > 0) {
          <app-child-selector
            class="w-full block"
            (childSelected)="this.childSelected($event)"
            />
        }
    
        @if (this.enterpriseData && this.enterpriseData.canOrderMultiple) {
          <div
            class="w-full px-6 flex flex-col border-b border-gris-3 pt-2 pb-2 mb-1 hidden md:block"
            >
            <p class="w-full text-center font-semibold fg-noir-2 text-sm">
              Commande de groupe (max. {{ this.enterpriseData.maxOrderNumber }})
            </p>
            <qty-selector
              class="w-32 h-8 mx-auto block"
              [min]="1"
              [value]="this.groupOrderQuantity"
              [max]="this.enterpriseData.maxOrderNumber"
              (quantityChange)="this.groupOrderQuantityChanged($event)"
              />
            </div>
          }
    
          <div class="flex-1 w-full flex flex-col overflow-y-scroll px-2">
            <!-- Rappel de l'admission en mode desktop/tablette -->
            @if (this.cartItems.length === 0 && this.selectedAdmission) {
              <div
                class="hidden md:block rounded bg-orange-3 py-2 border border-orange-1 pb-4 mt-2"
                >
                <p class="w-full py-1 text-center font-semibold text-md px-2">
                  {{ this.selectedAdmission.admissionName }}
                </p>
                <p class="w-full py-1 text-justify font-medium text-sm px-2 mb-2">
                  {{ this.selectedAdmission.admissionDescription }}
                  {{
                  this.selectedAdmission.admissionDescription.endsWith(':') ? '' : ':'
                  }}
                </p>
                <ul>
                  @for (item of this.filteredComponents; track item) {
                    <li
                      [class.font-semibold]="item.isMandatory"
                      class="text-sm px-4"
                      >
                      <span>
                        {{
                        item.quantity +
                        'x ' +
                        item.serviceName +
                        ' ' +
                        (item.isMandatory ? '(Obligatoire)' : '(Facultatif)')
                        }}
                      </span>
                    </li>
                  }
                </ul>
              </div>
            }
            @for (item of this.cartItems | orderBy : 'rankSort'; track item) {
              <cart-item-row
                [currentService]="this.currentService"
                [item]="item"
                [iconsServices]="this.iconsServices()"
                class="max-w-full"
                />
            }
          </div>
          <div
            class="w-[90%] mx-auto p-4 bg-gris-4 mb-[5%] border border-gris-3 rounded relative flex flex-col items-center justify-center gap-2"
            >
            @if (this.ent && this.ent.isAcceptPayment) {
              <div
                class="flex items-center gap-2 justify-between w-full"
                >
                <div class="flex items-center gap-2">
                  <div class="p-2 bg-vert-3 rounded">
                    <svg class="w-6 h-6 fg-vert-1">
                      <use href="/assets/images/icons/icons.svg#commande"></use>
                    </svg>
                  </div>
                  <p class="font-semibold fg-noir-2 text-xs">Total:</p>
                </div>
                <p class="font-bold fg-noir-2 text-sm">
                  {{ this.computeCartTotal().toFixed(2) }}€
                </p>
              </div>
            }
            <mk-icon-button
              (click)="this.checkout()"
              [height]="40"
              [icon]="this.isReadyForOrder ? 'check' : 'warning'"
              [label]="this.isReadyForOrder ? 'Passer la commande' : 'Menu incomplet'"
              [type]="this.isReadyForOrder ? 'primary' : 'dark'"
              class="w-full mt-2 text-xs btn-checkout"
              [useSvg]="this.isReadyForOrder ? 'true' : 'false'"
              />
            </div>
          </div>`,
    changeDetection: ChangeDetectionStrategy.Eager,
    styles: [
        `
      ::ng-deep .btn-checkout span.material-icons {
        font-size: 22px;
        padding-right: 4px;
        color: #f8b133 !important;
      }
    `,
    ]
})
export class CartDisplayComponent implements OnInit, OnDestroy {
  private cart = inject(CartService);
  protected qdm = inject(QdmService);
  private cdr = inject(ChangeDetectorRef);
  private modal = inject(ModalService);
  private toast = inject(ToastrService);
  private gestion = inject(GestionService);
  private auth = inject(AuthService);
  private responsive = inject(ResponsiveService);

  sub: Subscription = new Subscription();
  selectedDate: Date | undefined;
  currentService: ServiceItem | undefined;
  childId: number = -1;
  cartItems: CartItem[] = [];
  fullCart: CartStructure[] = [];
  child: UserChildren | null = null;
  selectedAdmission: FullAdmissionsData | null = null;
  groupOrderQuantity: number = 1;
  isReadyForOrder: boolean = false;
  ent: Enterprise | undefined = undefined;
  enterpriseData: EnterpriseResponse | null = null;
  user: User | undefined = undefined;
  showedInMobile: boolean = false;
  lastShownAdmissionId: number | null = null;

  // Static variable to persist across component instances
  private static globalLastShownAdmissionId: number | null = null;

  readonly iconsServices = input.required<{
    [key: number]: {
        url: string;
        bg: string;
    };
}>();

  get filteredComponents(): AdmissionPart[] {
    if (!this.selectedAdmission) {
      return [];
    }

    const componentsIds =
      this.currentService?.components.map((c) => c.family_id || c.id) || [];
    return this.selectedAdmission.admissionParts.filter((part) =>
      componentsIds.includes(part.serviceId)
    );
  }

  ngOnInit(): void {
    this.cart.init();

    this.sub.add(
      this.qdm.selectedDate$.subscribe((date) => {
        this.selectedDate = date;
        this.cdr.detectChanges();

        this.updateCart();
      })
    );

    this.sub.add(
      this.qdm.groupOrderQuantity$.subscribe((groupOrderQuantity) => {
        this.groupOrderQuantity = groupOrderQuantity;
        this.cdr.detectChanges();
      })
    );

    this.sub.add(
      this.qdm.selectedAdmission$.subscribe((admission) => {
        this.selectedAdmission = admission;
        this.cdr.detectChanges();
        if(admission){
          this.rappelAdmissionToast(true);
        }
        this.updateCart();
      })
    );

    this.sub.add(
      this.qdm.selectChild$.subscribe((child) => {
        this.childId = child?.id || -1;
        this.child = child;
        this.cdr.detectChanges();

        this.updateCart();
      })
    );
    this.sub.add(
      this.qdm.currentService$.subscribe((svc) => {
        this.currentService = svc;
        this.cdr.detectChanges();

        this.updateCart();
      })
    );
    this.sub.add(
      this.cart.cart$.subscribe((cart) => {
        this.fullCart = cart;
        this.cdr.detectChanges();

        this.updateCart();
      })
    );
    this.sub.add(
      this.qdm.selectedEnterprise$.subscribe((ent) => {
        this.ent = ent;
        this.cdr.detectChanges();
      })
    );

    this.sub.add(
      this.auth.userEnterprise$.subscribe((ent) => {
        this.enterpriseData = ent;
        this.cdr.detectChanges();
      })
    );

    this.sub.add(
      this.auth.user$.subscribe((user) => {
        this.user = user;
        this.cdr.detectChanges();
      })
    );
  }

  updateCart() {
    this.cartItems =
      this.fullCart.find(
        (c) =>
          c.childId === this.childId &&
          c.date === this.selectedDate?.formatDate('forApi') &&
          c.serviceId === this.currentService?.id
      )?.items || [];

    this.cdr.detectChanges();
    if (this.selectedAdmission) {
      if(this.selectedAdmission.isFullMenu){
        this.isReadyForOrder = true;
        return;
      }

      const mandatoryComposantes = this.selectedAdmission.admissionParts
        .filter((part) => part.isMandatory === 1)
        .map((part) => {
          return {
            id: part.serviceId,
            quantity: part.quantity * this.groupOrderQuantity,
          };
        });

      const itemCounts: { [key: number]: number } = {};

      this.cartItems.forEach((item) => {
        itemCounts[item.rankId] =
          (itemCounts[item.rankId] || 0) + item.quantity;
      });

      const meatFullCourses = this.cartItems.filter(
        (item) => item.isMeatFullCourse
      );
      const veganFullCourses = this.cartItems.filter(
        (item) => item.isVeganFullCourse
      );

      const legumeServices = this.selectedAdmission.admissionParts
        .filter((part) => part.isLegume === 1)
        .map((part) => part.serviceId);

      const viandePrincipaleIds = this.selectedAdmission.admissionParts
        .filter((part) => part.isLegume === 0 && part.isMandatory === 1)
        .map((part) => part.serviceId);

      if (legumeServices.length > 0 && viandePrincipaleIds.length > 0) {
        meatFullCourses.forEach((item) => {
          legumeServices.forEach((legumeId) => {
            itemCounts[legumeId] = (itemCounts[legumeId] || 0) + item.quantity;
          });
        });

        veganFullCourses.forEach((item) => {
          legumeServices.forEach((legumeId) => {
            itemCounts[legumeId] = (itemCounts[legumeId] || 0) + item.quantity;
          });
        });
      }

      const isMaxComposantesRequired =
        this.selectedAdmission.maxRequired || false;

      // Calculer le nombre total d'items dans le panier
      const totalItemsInCart = Object.values(itemCounts).reduce(
        (sum, count) => sum + count,
        0
      );

      // Vérifier si tous les items obligatoires sont présents
      const hasAllMandatoryItems = mandatoryComposantes.every(
        (mandatoryItem) =>
          itemCounts[mandatoryItem.id] >= mandatoryItem.quantity
      );

      // Si maxRequired est true, vérifier aussi le nombre total d'items
      if (isMaxComposantesRequired) {
        this.isReadyForOrder =
          this.cartItems.length > 0 &&
          hasAllMandatoryItems &&
          totalItemsInCart >=
            this.selectedAdmission.admissionMax * this.groupOrderQuantity;
      } else {
        this.isReadyForOrder =
          this.cartItems.length > 0 && hasAllMandatoryItems;
      }
    } else {
      if (this.cartItems.length > 0) {
        this.isReadyForOrder = true;
      } else {
        this.isReadyForOrder = false;
      }
    }

    this.cdr.detectChanges();
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  checkout() {
    if (!this.qdm.selectedEnterpriseSubject.value) {
      return;
    }

    if (!this.currentService) {
      return;
    }

    if (!this.selectedDate) {
      return;
    }

    if (!this.selectedAdmission && this.cartItems.length === 0) {
      this.toast.error('Votre panier est vide...');
      return;
    }

    if (this.selectedAdmission && this.cartItems.length === 0) {
      // rappel du menu
      this.rappelAdmissionToast();
      return;
    }

    if (!this.isReadyForOrder) {
      // Calculer d'abord les comptes réels avec les plats complets
      const itemCounts: { [key: number]: number } = {};

      // Compter les items standards
      this.cartItems.forEach((item) => {
        itemCounts[item.rankId] =
          (itemCounts[item.rankId] || 0) + item.quantity;
      });

      // Compter les plats complets
      const meatFullCourses = this.cartItems.filter(
        (item) => item.isMeatFullCourse
      );
      const veganFullCourses = this.cartItems.filter(
        (item) => item.isVeganFullCourse
      );

      // Trouver les IDs des services légumes
      const legumeServices =
        this.selectedAdmission?.admissionParts
          .filter((part) => part.isLegume === 1)
          .map((part) => part.serviceId) || [];

      // Pour chaque plat complet viande, ajouter un comptage pour le légume
      meatFullCourses.forEach((item) => {
        legumeServices.forEach((legumeId) => {
          itemCounts[legumeId] = (itemCounts[legumeId] || 0) + item.quantity;
        });
      });

      // Pour chaque plat complet légume, ajouter un comptage pour le légume (2x)
      veganFullCourses.forEach((item) => {
        legumeServices.forEach((legumeId) => {
          itemCounts[legumeId] = (itemCounts[legumeId] || 0) + item.quantity;
        });
      });

      const missingItems = (
        this.selectedAdmission?.admissionParts
          .filter((part) => part.isMandatory === 1)
          .map((part) => {
            return {
              id: part.serviceId,
              quantity:
                part.quantity * this.groupOrderQuantity -
                (itemCounts[part.serviceId] || 0),
              name:
                this.currentService?.components.find(
                  (c) => (c.family_id || c.id) === part.serviceId
                )?.name || part.serviceName || 'Inconnu',
            };
          }) || []
      ).filter((it) => it.quantity > 0);

      // Calculer le nombre total d'items dans le panier
      const totalItemsInCart = Object.values(itemCounts).reduce(
        (sum, count) => sum + count,
        0
      );
      const requiredTotalItems = this.selectedAdmission?.admissionMax
        ? this.selectedAdmission.admissionMax * this.groupOrderQuantity
        : 0;

      if (
        (this.selectedAdmission?.maxRequired || false) &&
        totalItemsInCart < requiredTotalItems
      ) {
        this.toast.warning(
          `Vous devez sélectionner au minimum ${requiredTotalItems} plats au total pour passer la commande. Vous en avez actuellement ${totalItemsInCart}.`,
          'Nombre de plats insuffisant',
          { enableHtml: true }
        );
        return;
      }

      if (missingItems.length > 1) {
        this.toast.warning(
          `Vous devez ajouter: <br><b>${missingItems
            .map((item) => `${item.quantity}x ${item.name}`)
            .join('<br />')}</b><br> pour passer la commande`,
          'Admission non respectée',
          { enableHtml: true }
        );
      } else if (missingItems.length === 1) {
        this.toast.warning(
          `Il vous manque: <br> <b>${missingItems[0].quantity}x ${missingItems[0].name}</b><br> pour passer la commande`,
          'Admission non respectée',
          { enableHtml: true }
        );
      }

      return;
    }
    this.gestion
      .checkPeriodcity(
        this.selectedDate.formatDate('forApi'),
        this.qdm.selectedEnterpriseSubject.value.id,
        this.currentService.mealtime_id!
      )
      .then((r) => {
        if (!r) {
          this.toast.error(
            'Vous ne pouvez pas commander pour ce service et cette date...'
          );
          return;
        }

        this.modal.open(
          ModalCartCheckoutComponent,
          {
            date: this.selectedDate,
            service: this.currentService,
            child: this.child,
            restaurant: this.qdm.selectedRestaurantSubject.value,
            total: this.computeCartTotal(),
            admission: this.qdm.selectedAdmissionSubject.value,
            enterprise: this.auth.userEnterpriseSubject.value,
            groupOrderQuantity: this.qdm.groupOrderQuantitySubject.value,
            iconsServices: this.iconsServices(),
          },
          () => {}
        );
      });
  }

  rappelAdmissionToast(checkMobile: boolean = false) {
    // For mobile, check if we should show the toast
    if (window.innerWidth < 768) {
      // Only show on mobile if explicitly requested (checkMobile=true)
      if (!checkMobile) {
        return;
      }
      
      // if already showed for this admission, don't show again
      if (this.selectedAdmission && CartDisplayComponent.globalLastShownAdmissionId === this.selectedAdmission.admissionId) {
        return;
      }
      
      // Mark this admission as shown BEFORE showing the toast
      if (this.selectedAdmission) {
        CartDisplayComponent.globalLastShownAdmissionId = this.selectedAdmission.admissionId;
      }
    } else {
      // For desktop, only show if NOT explicitly checking mobile (i.e., from checkout)
      if (checkMobile) {
        return;
      }
    }


    let html = '';
    this.selectedAdmission?.admissionParts.forEach((part) => {
      html += `<span class="${
        part.isMandatory === 1 ? 'font-bold' : 'font-medium'
      }">${part.quantity * this.groupOrderQuantity}x ${part.serviceName} ${
        part.isMandatory === 1 ? '(Obligatoire)' : ''
      }</span><br>`;
    });
    
    // Different title based on whether it's a mobile check or not
    const title = checkMobile ? 'Rappel de l\'admission' : 'Admission non respectée';
    
    this.toast.warning(
      `Pour rappel, voici le menu choisi: <br><br>${html}`,
      title,
      { enableHtml: true }
    );
  }

  protected computeCartTotal(): number {
    if (!this.currentService) return 0;
    if (!this.selectedDate) return 0;

    const childId = this.child ? this.child.id : -1;

    if (this.selectedAdmission) {
      const supplementsPrices = this.cartItems
        .filter((item) => this.isExtra(item.id))
        .reduce((acc, item) => acc + item.displayedPrice * item.quantity, 0);
      return (
        this.selectedAdmission.finalPrice * this.groupOrderQuantity +
        supplementsPrices
      );
    } else {
      if (this.qdm.selectedRestaurantSubject.value) {
        return this.cart.computeCartTotal(
          this.currentService.id,
          this.qdm.selectedRestaurantSubject.value.id,
          childId,
          this.selectedDate
        );
      }

      return 0;
    }
  }

  isExtra(courseId: number): boolean {
    const rank = this.currentService?.components.find((c) =>
      c.courses.some((course) => course.id === courseId)
    );
    if (!rank) return false;

    const course = rank.courses.find((course) => course.id === courseId);
    if (!course) return false;

    return course.is_extra;
  }

  groupOrderQuantityChanged($event: number) {
    this.qdm.groupOrderQuantitySubject.next($event);
    // Le clearCart et l'ajout des éléments obligatoires sont maintenant gérés 
    // par la souscription à groupOrderQuantity$ dans RestaurantSelectedMainPage
  }

  closeCart() {
    this.responsive.isMobileCartShowedSubject.next(false);
  }

  childSelected(child: UserChildren) {
    this.cart.readCartContent();
  }
}
